import React, { Component, Fragment } from "react";

import { Spinner } from "./Spinner";
import DraftsIcon from "@material-ui/icons/Drafts";
import { acquireToken } from "../adalConfig";

import {
  DialogActions,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogTitle,
  Tooltip,
  IconButton,
  //Typography,
  //Box,
} from "@material-ui/core/";
import axios from "axios";
import { LoggedUserContext } from "../LoggedUserContext";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export default class CampaignsEmailStatus extends Component {
  state = {
    open: false,
    loading: false,
    emailSendSummarySended: -1,
    emailSendSummaryNotSended: -1,
    emailSendSummaryError: -1,
  };

  handleToggle = () => {
    this.UpdateEmailStatus();
    this.setState({
      open: !this.state.open,
    });
  };

  componentDidMount() {
    this.UpdateEmailStatus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.UpdateEmailStatus();
    }
  };

  render() {
    const {
      open,
      loading,
      emailSendSummarySended,
      emailSendSummaryNotSended,
      emailSendSummaryError,
    } = this.state;

    return (
      <Fragment>
        <Tooltip title="Email delivery status">
            <IconButton
            onClick={this.handleToggle}
            style={{ backgroundColor: "#797991" }}
            aria-label="summary"
            >
            <DraftsIcon />
            </IconButton>
        </Tooltip>
        <Dialog open={open} onClose={this.handleToggle} style={{ zindex: 100 }}>
          {loading ? (
            <Spinner />
          ) : (
            <div>
              <DialogTitle id="form-dialog-title">
                Email delivery status
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Total Emails:{" "}
                  {emailSendSummarySended +
                    emailSendSummaryNotSended +
                    emailSendSummaryError}
                </DialogContentText>
                <DialogContentText>
                  Pending Emails: {emailSendSummaryNotSended}
                </DialogContentText>
                <DialogContentText>
                  Sent Emails: {emailSendSummarySended}
                </DialogContentText>
                <DialogContentText>
                  Email Errors: {emailSendSummaryError}
                </DialogContentText>
              </DialogContent>
              <DialogActions></DialogActions>
            </div>
          )}
        </Dialog>
      </Fragment>
    );
  }

  async UpdateEmailStatus() {
    this.setState({ loading: true });

    acquireToken().then((token) => {
      let url = `${process.env.REACT_APP_API_URL}/CampaingAPI/GetSendedEmailsSummaryPerCampaing/${this.props.id}`;
      axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            this.setState({
              emailSendSummarySended: res.data.items[0].emailSendSummarySended,
              emailSendSummaryNotSended:
                res.data.items[0].emailSendSummaryNotSended,
              emailSendSummaryError: res.data.items[0].emailSendSummaryError,
              loading: false,
            });
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the campaign information",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title:
                "An error has occurred while retrieving the campaign information",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });
  }
}

CampaignsEmailStatus.contextType = LoggedUserContext;
